import { FC } from 'react';
import { NextTable } from '@shared/modules/next-table/containers';
import { CashFlowTransactionsTableContext } from '../context';
import { useCashFlowTransactionsTable } from '../hooks';

export const CashFlowTransactionsTable: FC = () => {
  const { columns, getRowProps } = useCashFlowTransactionsTable();
  return <NextTable context={CashFlowTransactionsTableContext} columns={columns} getRowProps={getRowProps} />;
};
